import React from 'react'

export const Error = () => {
  return (
    <div className='container-fluid'>
       <h3>Error 404</h3>
    </div>
  )
}
